import React, {PropsWithChildren} from 'react';
import BusinessProvider from "./BusinessProvider";
import {ModalProvider} from "./ModalContext";
import {ToastProvider} from "./ToastContext";

const Providers = ({children}: PropsWithChildren) => {
    return (
        <ToastProvider>
            <ModalProvider>
                <BusinessProvider>
                    {children}
                </BusinessProvider>
            </ModalProvider>
        </ToastProvider>
    );
};

export default Providers;
